WiseMetering.Views.DestroyCircuitTag = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.circuit_tags.destroy')
});
